import { apiRequest } from "../client";
import { getStandardExposureChartOptions } from "@/utils/exposureChartTypes";

export interface ExposureType {
    value: string;
    label: string;
    categories?: string[];
}

export interface StatisticField {
    value: string;
    label: string;
}

export interface AvailableExposuresResponse {
    exposure_types: ExposureType[];
    metadata: Record<string, any>;
}

export interface AvailableStatisticsResponse {
    statistics: StatisticField[];
    metadata: Record<string, any>;
}

export const fetchAvailableExposures = async (): Promise<ExposureType[]> => {
    try {
        const response = await apiRequest<AvailableExposuresResponse>({
            method: "GET",
            url: "/widgets/available-exposures-for-builder",
        });
        return response.exposure_types;
    } catch (error) {
        console.error("Failed to fetch available exposures:", error);
        // Return standard defaults if API fails (matches playground STANDARD_EXPOSURE_TYPES)
        return getStandardExposureChartOptions();
    }
};

export const fetchAvailableStatistics = async (): Promise<StatisticField[]> => {
    try {
        const response = await apiRequest<AvailableStatisticsResponse>({
            method: "GET",
            url: "/widgets/available-statistics-for-builder",
        });
        return response.statistics;
    } catch (error) {
        console.error("Failed to fetch available statistics:", error);
        // Return empty array if API fails
        return [];
    }
};

